(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("javascript-inviewport", [], factory);
	else if(typeof exports === 'object')
		exports["javascript-inviewport"] = factory();
	else
		root["javascript-inviewport"] = factory();
})(this, function() {
return 